import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type PolicyAgencyCodesTreeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PolicyAgencyCodesTreeQuery = { __typename?: 'Query', sourceCodes: { __typename?: 'SourceCodes', policyAgencyCodes: Array<{ __typename?: 'AgencyCodeCategory', key: string, title: string, children: Array<{ __typename?: 'AgencyCode', key: string, title: string }> }>, policySources: Array<{ __typename?: 'AgencyCode', id: string, name: string }> } };


export const PolicyAgencyCodesTreeDocument = gql`
    query PolicyAgencyCodesTree {
  sourceCodes {
    policyAgencyCodes {
      key: id
      title: name
      children: codes {
        key: id
        title: name
      }
    }
    policySources {
      id
      name
    }
  }
}
    `;

/**
 * __usePolicyAgencyCodesTreeQuery__
 *
 * To run a query within a React component, call `usePolicyAgencyCodesTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyAgencyCodesTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyAgencyCodesTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePolicyAgencyCodesTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>(PolicyAgencyCodesTreeDocument, options);
      }
export function usePolicyAgencyCodesTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>(PolicyAgencyCodesTreeDocument, options);
        }
// @ts-ignore
export function usePolicyAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>;
export function usePolicyAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PolicyAgencyCodesTreeQuery | undefined, PolicyAgencyCodesTreeQueryVariables>;
export function usePolicyAgencyCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>(PolicyAgencyCodesTreeDocument, options);
        }
export type PolicyAgencyCodesTreeQueryHookResult = ReturnType<typeof usePolicyAgencyCodesTreeQuery>;
export type PolicyAgencyCodesTreeLazyQueryHookResult = ReturnType<typeof usePolicyAgencyCodesTreeLazyQuery>;
export type PolicyAgencyCodesTreeSuspenseQueryHookResult = ReturnType<typeof usePolicyAgencyCodesTreeSuspenseQuery>;
export type PolicyAgencyCodesTreeQueryResult = Apollo.QueryResult<PolicyAgencyCodesTreeQuery, PolicyAgencyCodesTreeQueryVariables>;